import { render, staticRenderFns } from "./OrderDetail-out.vue?vue&type=template&id=2d00d711&scoped=true&"
import script from "./OrderDetail-out.vue?vue&type=script&lang=js&"
export * from "./OrderDetail-out.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail-out.vue?vue&type=style&index=0&id=2d00d711&prod&lang=css&"
import style1 from "./OrderDetail-out.vue?vue&type=style&index=1&id=2d00d711&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00d711",
  null
  
)

export default component.exports